<template>
    <div>
        <barraprincipaladmin @abrir="mtMenuVisible"> </barraprincipaladmin>
        <menulateral @cerrar="mtMenuVisible" :value="menu_visible"> </menulateral>

        <v-container fluid> 

            <div class="claro elevation-5">
                <v-row dense>     
                    <v-col cols="12" md="12" class="d-flex align-center px-4">
                        <h2 class="primary--text">Usuarios.</h2>                    
                    </v-col>                    
                </v-row>
            </div>      

            <br> 
           
            
            <v-row>
                <v-col cols="12" md="12" class="d-flex justify-end">
                    <v-btn color="primary" dense to="/admincrearusuario" > <v-icon left>mdi-plus-thick</v-icon> Nuevo usuario</v-btn>
                </v-col>    
            </v-row>    

            <v-row>
                <v-col cols="12" md="12">

                    <div class="mx-0">
                        <v-data-table 
                            dense 
                            :headers="tabla_encabezado" 
                            :items="usuarios"
                            :item-class="color_fondo"                        
                            :items-per-page="-1"
                            class="elevation-1"
                            mobile-breakpoint="100"                       
                            multi-sort
                            :search="busqueda"   
                            loading-text="Consultando información..."
                            :loading="cargando"
                            no-data-text="No se encontró información."
                            locale="es-MX"
                            :footer-props="{
                                'items-per-page-text':'Usuarios por página',
                                'items-per-page-all-text': 'Todos',
                                'show-current-page':true,
                                'show-first-last-page': true,                                                                                 
                                'page-text':page_text
                            }"
                            @pagination="texto_paginacion"                                         
                        >      
                        </v-data-table>
                    </div>


                </v-col>
            </v-row>


    
            <v-snackbar v-model="snackbar" :color="snackbarcolor" light >
                <div class="d-flex justify-center"><strong>{{snackbartexto}}</strong></div>
            </v-snackbar>        
    
        </v-container>
    </div>
</template>

<script>

import menulateral from "@/components/MenuLateralAdmin";
import barraprincipaladmin from "@/components/BarraPrincipalAdmin";

export default {

    components:{
        menulateral,
        barraprincipaladmin,
    },

    data() {
        return {
            menu_visible: false,

            snackbartexto: "",
            snackbar: false,            
            snackbarcolor: "",  
                        
            busqueda:'',
            tabla_encabezado:[],
            usuarios: [],
            page_text:'',
            cargando:true,           
                        
            color_fondo:"blue lighten-4",


        }
    },   

    beforeCreate() {
        const token = sessionStorage.getItem('datax')
               
        this.axios.post(this.$url+'/acceso/validatoken/usuario', {}, {headers: {Authorization: `Bearer ${token}`}})     
            .then((response)=>{

                const data = response.data
                
                if(data.codigo == 'lgout')
                    this.$router.push({"name":'AdminLogin'})
            
            })
            .catch((error)=>{
                console.log("Error "+error);
            })
    },

    created() {
        this.getInformacion()
    },

    methods: {
        mtMenuVisible(value){
            this.menu_visible = value
        },   
        
        texto_paginacion: function(pg){           
            this.page_text = 'Total usuarios '+pg.itemsLength
        },
        
        getInformacion(){
            this.cargando = true
            this.axios.get(this.$url+'/admin/usuarios/listado')
                .then((response)=>{
                    const data = response.data
                    
                    console.log(response.data);

                    if(!data.error){
                        //Encabezados de la tabla
                        for(let key in data.usuarios[0])                            
                            this.tabla_encabezado.push({
                                text:key.toUpperCase(), 
                                value:key, 
                                class:"black--text"                        
                            })  
                            
                        //Agrego la columna de acciones a la tabla
                        this.tabla_encabezado.push({
                            text:"ACCIONES",
                            value:"acciones",
                            class:"black--text"
                        })

                        this.usuarios = data.usuarios
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                    }


                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        },

        setRegistro(usuario){

            this.registrando = true
            this.axios.post(this.$url+"/admin/usuarios/crear", {datos: usuario})
                .then((response)=>{
                    let rs = response.data

                    if(rs.error && rs.correo){
                        this.snackbartexto = rs.mensaje
                        this.snackbar = true   
                        this.snackbarcolor = "red"
                    }
                    else{
                        this.snackbartexto = "Usuario creado, redirigiendo..."
                        this.snackbar = true
                        this.snackbarcolor = "green"

                        // setTimeout(() => {
                        //     this.$router.push({name:'Login'})                            
                        // }, 2000);

                    }

                    console.log(rs);
                    
                })
                .catch(() =>{
                    this.snackbartexto = "Ocurrió un error en el registro."
                    this.snackbar = true
                    this.snackbarcolor = "red"
                })
                .finally(()=>{
                    this.registrando = false
                })

        }

    },

}
</script>
 
<style>
  
   
</style>